<template>
	<div class="innerBox">
		<div class="rounded border border-secondary p-30" style="color:white;background-color:black;min-height:300px">
			<div class="row">
				<div class="col-md-3 mt-auto mb-auto text-center">
					<i class="fa fa-arrow-right fa-4x"></i>
				</div>
				<div class="col-md-9 pl-4 pr-4">
					<label>To Account :</label>
					<Multiselect 
						:options="accountTransaction.map(x => x.id)"
						:custom-label="opt => accountTransaction.find(x => x.id == opt).account_name"
						v-model="accountTo"
					/>
					<div v-if="accountTo" class="mt-3">
						<h5>Balance : Rp. {{ numberWithCommas(accountTransaction.find( x => x.id == accountTo).balance)}}</h5>
					</div>
				</div>
				
			</div>
			<div class="row mt-5 pl-3 pr-3 text-center">
				<div class="col-3 middleDiv">
					<h5>Jumlah Rupiah <span class="text-red">*</span></h5>
				</div>
				<div class="col-2 middleDiv">
					<h5>:</h5>
				</div>
				<div class="col-7">
					<input 
						type="text"
						class="w-100 form-control"
						v-model="amount"
					/>
				</div>
			</div>
			<div class="row mt-3 pl-3 pr-3 text-center">
				<div class="col-3 middleDiv">
					<h5>Deskripsi <span class="text-red">*</span></h5>
				</div>
				<div class="col-2 middleDiv">
					<h5>:</h5>
				</div>
				<div class="col-7">
					<input 
						type="text"
						class="w-100 form-control"
						v-model="deskripsi"
					/>
				</div>
			</div>
			<div class="row mt-3 text-center pl-3 pr-3">
				<div class="col-3 middleDiv">
					<h5>Tanggal Pembayaran <span class="text-red">*</span></h5>
				</div>
				<div class="col-2 middleDiv">
					<h5>:</h5>
				</div>
				<div class="col-7">
					<flat-pickr
						v-model="payment_date"
						:config="rangeConfig"
						placeholder="Pilih Tanggal"
					></flat-pickr>	
				</div>
			</div>
			<div class="mt-4 text-right pl-3 pr-3">
				<button class=" btn btn-primary btn-lg" @click="submitTransaction">Submit Transaction</button>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
	props : ['accountTransaction'],
	components : {
		Multiselect
	},
	data () {
		return {
			accountTo : null,
			amount : 0,
			deskripsi : '',
			payment_date : '',
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
			},
		}
	},
	watch : {
		amount : function () {
			const result = this.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.amount = result);
        },
	},
	methods : {
		submitTransaction () {
			if(!this.amount || !this.accountTo || !this.deskripsi || !this.payment_date) { 
				this.$store.dispatch('triggerAlert' , [false , 'Please Fill all the required Fields.'])
				return
			}
				
			this.$http.post('/api/v1/transactions/payments/incoming' , {
				amount : parseFloat(this.amount.split(',').join('')),
				account_transaction_id : this.accountTo,
				description : this.deskripsi
			})
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Transaction Submitted Successfully'])
				this.accountTo = null
				this.amount = 0
				this.deskripsi = ''
				this.$emit('recheckBalance')
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Transaction Failed.'])
				console.log(err)
			})
		}
	}
}
</script>